import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../auth/AuthContext";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReporteFaltaPipa() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [ciudadano, setCiudadano] = useState("");
  const [telefono, setTelefono] = useState("");
  const [direccion, setDireccion] = useState("");
  const [colonia, setColonia] = useState("");
  const [prioridad, setPrioridad] = useState("NORMAL");
  const [observaciones, setObservaciones] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/reportes-falta-pipa`, {
        ciudadano, telefono, direccion,
        colonia: colonia || null,
        prioridad,
        observaciones: observaciones || null,
      });
      const folio = data?.reporte?.folio || "?";
      toast.success(`Reporte ${folio} registrado · se notificará al supervisor de zona`);
      setCiudadano(""); setTelefono(""); setDireccion(""); setColonia("");
      setPrioridad("NORMAL"); setObservaciones("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo guardar el reporte");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="hub-bg" data-testid="page-reporte">
      <header className="topnav">
        <div className="brand">
          <button onClick={() => navigate("/hub")} className="iconbtn mr-1"><i className="fa-solid fa-arrow-left"/></button>
          <div className="logo" style={{background:"#78350F"}}><i className="fa-solid fa-bell-concierge"/></div>
          <div><div className="title">Reporte Falta Pipa</div><div className="sub">Atención ciudadana directa</div></div>
        </div>
        <div className="actions">
          <button onClick={logout} className="btn-ghost" style={{padding:"0.5rem 0.9rem"}}><i className="fa-solid fa-right-from-bracket mr-1"/>Salir</button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-7">
        <h1 className="text-2xl font-bold">Registrar reporte ciudadano</h1>
        <p className="text-slate-500 text-sm mt-1">Captura un reporte de un ciudadano que indica que no le llegó la pipa, o necesita servicio.</p>

        <form className="card-base mt-6 grid grid-cols-1 md:grid-cols-2 gap-4" onSubmit={submit}>
          <div className="field"><label>Nombre del ciudadano *</label><input required value={ciudadano} onChange={e=>setCiudadano(e.target.value)} placeholder="Nombre completo" data-testid="inp-ciudadano"/></div>
          <div className="field"><label>Teléfono *</label><input required value={telefono} onChange={e=>setTelefono(e.target.value)} placeholder="614-XXX-XXXX" data-testid="inp-tel"/></div>
          <div className="field md:col-span-2"><label>Dirección *</label><input required value={direccion} onChange={e=>setDireccion(e.target.value)} placeholder="Calle, número, colonia" data-testid="inp-dir"/></div>
          <div className="field"><label>Colonia</label><input value={colonia} onChange={e=>setColonia(e.target.value)} placeholder="Ej: Cumbres" data-testid="inp-col"/></div>
          <div className="field"><label>Prioridad</label>
            <select value={prioridad} onChange={e=>setPrioridad(e.target.value)} data-testid="sel-prio">
              <option value="NORMAL">NORMAL</option>
              <option value="ALTA">ALTA</option>
              <option value="URGENTE">URGENTE (escuela / hospital)</option>
            </select>
          </div>
          <div className="field md:col-span-2"><label>Observaciones</label><input value={observaciones} onChange={e=>setObservaciones(e.target.value)} placeholder="Detalles, días sin servicio, etc." data-testid="inp-obs"/></div>
          <div className="md:col-span-2">
            <button type="submit" className="btn-primary" disabled={submitting} data-testid="btn-enviar">
              {submitting ? "Enviando..." : "REGISTRAR REPORTE"}
              <i className="fa-solid fa-arrow-right"/>
            </button>
          </div>
        </form>

        <div className="mt-4 text-xs text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg p-3">
          <i className="fa-solid fa-check-circle mr-1"/>
          Los reportes se guardan en la bandeja del supervisor con folio <strong>RFP-YYMMDD-NNN</strong> y origen <strong>CIUDADANO</strong>.
        </div>
      </main>
    </div>
  );
}
